<template>
    <div>
        <div>
            <p>Sincronizando...</p>
            <br>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TwilioWarning",
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent(){
            }
        }
    }
</script>

<style scoped>

</style>
